import { chimneyWheelbase, coverLayer } from '../conversion/drainageChimney';
import { drainPositionDepth, wheelbase } from '../conversion/drainageTrench';
import { EUnitOfMeasure } from '../shared/enum';
import { redux } from '../store';

export default () => {
    let project = redux.getState().project;
    return {
        [drainPositionDepth]: {
            min: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: undefined,
                    [EUnitOfMeasure.Imperial]: undefined,
                },
            },
            max: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: project.data?.slope?.impermeableLayerDepth! - 0.15,
                    [EUnitOfMeasure.Imperial]: project.data?.slope?.impermeableLayerDepth! - 0.49,
                },
            },
        },
        [wheelbase]: {
            min: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 1,
                    [EUnitOfMeasure.Imperial]: 3.2,
                },
            },
            max: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: project.data?.slope?.slopeWidth!,
                    [EUnitOfMeasure.Imperial]: project.data?.slope?.slopeWidth!,
                },
            },
        },
        [chimneyWheelbase]: {
            min: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 1,
                    [EUnitOfMeasure.Imperial]: 3.2,
                },
            },
            max: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 20,
                    [EUnitOfMeasure.Imperial]: 65.6,
                },
            },
        },
        [coverLayer]: {
            min: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: 0.5,
                    [EUnitOfMeasure.Imperial]: 1.5,
                },
            },
            max: {
                unitOfMeasure: {
                    [EUnitOfMeasure.Metric]: undefined,
                    [EUnitOfMeasure.Imperial]: undefined,
                },
            },
        },
    };
};
